import React, { FC, useEffect } from 'react'
import { EntityId } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { selectPlaylistById } from '@store/slices/playlist.slice'
import { AppDispatch, RootState } from '@store/store'
import {
  formatDate,
  toDateHourString,
  toHourMinString,
} from '@shared/tools/time.tools'

import { Col, ListGroup, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import {
  selectAllAuthors,
  selectAuthorByEmail,
  selectAuthorsLoading,
} from '@store/selectors/author.selectors'
import { AuthorModel } from '@store/slices/author.slice'
import { fetchAllAuthors } from '@store/thunk/author.thunk'

const PlaylistListComponent: FC<{ playlistIds: EntityId[] }> = ({
  playlistIds,
}) => {
  const dispatch = useDispatch<AppDispatch>()
  const authors = useSelector(selectAllAuthors)
  const authorsLoadin = useSelector(selectAuthorsLoading)

  useEffect(() => {
    if ((!authors || authors.length === 0) && !authorsLoadin) {
      dispatch(fetchAllAuthors())
    }
  }, [authors])

  return (
    <ListGroup>
      <ListGroup.Item active>
        <Row className="d-flex justify-content-between ">
          <Col style={{ maxWidth: '50px' }}>ID</Col>
          <Col xs={2}>Čas</Col>
          <Col style={{ maxWidth: '105px' }}>Počet slotů</Col>
          <Col xs={4}>Vytvořeno</Col>
          <Col xs={4}>Upraveno</Col>
        </Row>
      </ListGroup.Item>
      {playlistIds.map((playlistId) => (
        <PlaylistListRow key={playlistId} playlistId={playlistId} />
      ))}
    </ListGroup>
  )
}
export default PlaylistListComponent

export const PlaylistListRow: FC<{ playlistId: EntityId }> = ({
  playlistId,
}) => {
  const playlist = useSelector((state: RootState) =>
    selectPlaylistById(state, playlistId)
  )
  const createdBy: AuthorModel | undefined = useSelector((state: RootState) =>
    playlist ? selectAuthorByEmail(state, playlist.createdBy) : undefined
  )
  const updatedBy: AuthorModel | undefined = useSelector((state: RootState) =>
    playlist ? selectAuthorByEmail(state, playlist.updatedBy) : undefined
  )

  return (
    <ListGroup.Item
      key={playlist.id}
      as={Link}
      action
      to={`/playlist/${playlist.id}`}
    >
      <Row className="d-flex justify-content-between">
        <Col style={{ maxWidth: '50px' }}>{playlist.id}</Col>
        <Col xs={2}>
          {`${formatDate(playlist.fromTime)} ${toHourMinString(playlist.fromTime)}-${toHourMinString(playlist.toTime)}\t`}
        </Col>
        <Col
          className={'ps-3'}
          style={{ maxWidth: '105px' }}
        >{`${playlist.aiSlots.length}\t`}</Col>
        <Col xs={4}>
          {`${toDateHourString(playlist.createdAt)} ${!!createdBy?.username ? createdBy.username : createdBy?.email}`}
        </Col>
        <Col xs={4}>
          {`${toDateHourString(playlist.updatedAt)} ${!!updatedBy?.username ? updatedBy.username : updatedBy?.email}`}
        </Col>
      </Row>
    </ListGroup.Item>
  )
}
